import Mark from 'mark.js'; // eslint-disable-line import/no-unresolved

function searchHighlight() {
	const config = window.emSearchConfig;

	if (typeof config === 'undefined') {
		throw new Error('Could not find the search configuration data.');
	}

	const init = () => {
		const searchParams = new URL(document.location).searchParams;

		if (!searchParams.has('ytk_search_term')) {
			return;
		}

		const searchTerm = searchParams.get('ytk_search_term');

		highlightResults(searchTerm);
		maybeGoToFirstResult();
		maybeDisplayOffSwitch();
	};

	function highlightResults(searchTerm) {
		const container = document.querySelector('.block-root');

		if (!container) {
			return;
		}

		const mark = new Mark(container);
		mark.mark(searchTerm, {
			element: 'span',
			className: 'ytk-search-highlight',
		});
	}

	function maybeGoToFirstResult() {
		const firstResult = document.querySelector('.ytk-search-highlight');
		if (firstResult) {
			firstResult.scrollIntoView();
		}
	}

	function maybeDisplayOffSwitch() {
		const hasResults = document.querySelector('.ytk-search-highlight');
		if (hasResults) {
			// append button at the end of document to disable search highlights
			const button = document.createElement('button');
			button.classList.add('search-highlight-toggle');
			button.innerText =
				config?.text?.removeHighlights || 'Remove highlights';
			button.addEventListener('click', () => {
				document
					.querySelectorAll('.ytk-search-highlight')
					.forEach((el) => {
						// unwrap span element
						el.replaceWith(...el.childNodes);
					});
				button.classList.add('search-highlight-toggle--closing');
				setTimeout(
					(buttonEl) => {
						buttonEl.remove();
						// remove ?em_search_term from url
						const url = new URL(document.location);
						url.searchParams.delete('em_search_term');
						window.history.replaceState({}, '', url);
					},
					250,
					button
				);
			});
			// close button on escape key
			document.addEventListener('keydown', (e) => {
				if (e.key === 'Escape') {
					if (button) {
						button.click();
					}
				}
			});
			document.body.appendChild(button);
		}
	}

	init();
}

export default searchHighlight;
